import React, { useEffect } from 'react'
import apiFetch from '@wordpress/api-fetch'

import { CaseModal } from './components/CaseModal'
import { FilterPanel } from './components/FilterPanel'
import { Overlay } from './components/Overlay'
import { SystemModal } from './components/SystemModal'
import { WizardModal } from './components/WizardModal'
import { useWpDataInit } from './hooks/useWpDataInit'
import { ScreenRouter } from './ScreenRouter'
import { useWpDataStore } from './state/wpDataStore'

let apiConfigured = false
function ensureApiFetchConfigured(restRoot?: string, restNonce?: string) {
  if (apiConfigured) return
  if (restRoot) {
    apiFetch.use(apiFetch.createRootURLMiddleware(restRoot))
  }
  if (restNonce) {
    apiFetch.use(apiFetch.createNonceMiddleware(restNonce))
  }
  apiConfigured = true
}

export type AppProps = {
  restRoot?: string
  restNonce?: string
}

const App = (props: AppProps) => {
  const { restRoot, restNonce } = props

  // Configure apiFetch once
  useEffect(() => {
    ensureApiFetchConfigured(restRoot, restNonce)
  }, [restRoot, restNonce])

  // Kick off loading
  useWpDataInit(20, true)

  const { loading, error } = useWpDataStore()

  return (
    <div className='smart-guide-app-container'>
      <div className='container'>
        {loading && <p>Loading…</p>}
        {error && <p>Error: {error}</p>}

        {!loading && !error && (
          <>
            <ScreenRouter />
            <Overlay />
            <FilterPanel />

            {/* Modals */}
            <WizardModal />
            <SystemModal />
            <CaseModal />
          </>
        )}
      </div>
    </div>
  )
}

export { App }
